
import React from 'react';
import PropTypes from "prop-types";


ElencoNoteAttive.propTypes = {
    note: PropTypes.array,
    lavoratori: PropTypes.object,
    sedi: PropTypes.object
}

function ElencoNoteAttive({ note, lavoratori, sedi }) {

    const getLavoratore = (idLavoratore) => {
        return lavoratori[idLavoratore]
    }

    const getSedi = (sediKeys) => {
        return sediKeys.map(key => sedi[key]).join(", ");
    }

    const getPeriodoCompetenza = (inizio, fine) => {
        const formatDate = (date) => date.toLocaleDateString("it-IT");
        return `${formatDate(new Date(inizio))} - ${formatDate(new Date(fine))}`;
    };



    const printNote = () => {
        return note.map((nota, index) => {
            return (
                <tr key={nota.id}>
                    <td className="bordiSpessi nota-descrizione-wrap">{nota.descrizione}</td>
                    <td className="bordiSpessi center">{getLavoratore(nota.lavoratoreId)}</td>
                    <td className="bordiSpessi center">{getSedi(nota.sedi)}</td>
                    <td className="bordiSpessi center">{getPeriodoCompetenza(nota.inizio, nota.fine)}</td>
                    <td className="bordiSpessi center">{nota.tipo}</td>
                </tr>
            )
        })
    }

    return (
        <div className="table-responsive">
            <table className="table table-bordered space" id="tabella-note-attive" key="tabellanote">
                <thead className="App">
                    <tr key="intestazione">
                        <th className="inEvidenza bordiSpessi" style={{ width: '30%' }}>nota</th>
                        <th className="inEvidenza bordiSpessi">lavoratore</th>
                        <th className="inEvidenza bordiSpessi">sedi</th>
                        <th className="inEvidenza bordiSpessi">periodo di competenza</th>
                        <th className="inEvidenza bordiSpessi">tipo</th>
                    </tr>
                </thead>
                <tbody>
                    {printNote()}
                </tbody>
            </table>
        </div>
    );
}



export default ElencoNoteAttive;